import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { TwoColumnLayoutService } from 'src/app/common-components/column-layouts/two-column-list-layout/services/selected-id.service';
import { DepartmentDetailComponent } from '../../department-details/containers/department-detail.component';

@Component({
    selector: 'ndt-department-wrapper',
    styleUrls: ['./department-wrapper.component.scss'],
    templateUrl: './department-wrapper.component.html',
    standalone: false
})
export class DepartmentWrapperComponent implements AfterViewInit {
   @ViewChild(DepartmentDetailComponent) departmentDetailComponent;
   form: UntypedFormGroup;
   constructor(private twoColumnLayoutService: TwoColumnLayoutService) {}

   get showDetailView(): boolean {
      return !!this.twoColumnLayoutService.getFirstItemId();
   }

   ngAfterViewInit(): void {
      this.form = this.departmentDetailComponent.form;
   }
}
